import { Theme } from '@chakra-ui/react'

export interface NucbaStylesTheme extends Partial<Theme['styles']> {}

export const styles: NucbaStylesTheme = {
  global: {
    body: {
      background: 'nucba.background',
      WebkitTapHighlightColor: 'transparent',
    },
  },
}
